import * as React from "react";
import {Moment} from "moment";
import * as moment from "moment";
import { Link } from "react-router-dom";

interface IProps {
    claimSubmissionDate: string;
    submittedClaimNumber: string | undefined;
}

export class ClaimSubmissionBanner extends React.Component<IProps> {

    public render() {
        const {claimSubmissionDate} = this.props;
        const history: Moment = moment(moment.utc(), moment.ISO_8601).subtract(48, "hours");
        const claimSubmittedDate: Moment = moment.utc(claimSubmissionDate);
        const duration = moment.duration(claimSubmittedDate.diff(history));
        const difference: number = Math.round(duration.asHours());

        if (difference <= 0) {
            return <></>
        }

        if (this.props.submittedClaimNumber) {
            return (
                <div className="banner px-4 banner-info">
                    <p className="banner-text mb-0">
                        Heads up - We are reviewing your
                        <Link to="/dashboard/rentersClaims" id="reactivateSubscription"> renters claim no {this.props.submittedClaimNumber}. </Link>
                        We'll get in touch with you in {difference}h
                    </p>
                </div>
            );
        } else {
            return (
                <div className="banner px-4">
                    <p className="mb-0">You submitted a <span className="font-weight-bold">claim</span> and you’ll be <span className="font-weight-bold">contacted in</span>{' '}
                        the next <span className="font-weight-bold">{difference} hours</span>
                    </p>
                </div>
            );
        }
    }
}
